<template>
    <b-container style="margin-bottom:45px;">
        <b-button :disabled="shouldShowBuilder" href="#" variant="success" @click="onGenerateSerial">Generate Model Number</b-button>

        <p class="top-note">*Note: This Model Generator is intended as a companion for the series-specific Brochures, Submittals, and Design Guides available at heatcontroller.com.  For more detailed information regarding specific options, dimensions, and/or design parameters, please consult the available literature. </p>

          <b-button @click="shouldShowModal = !shouldShowModal" class="mt-4">
            Click here for additional horizontal, vertical, and downflow configuration details.
          </b-button>

        <builder-container v-if="shouldShowBuilder" @result="onBuilderResult" />

        <div v-if="products.length" class="mt-5">
            <b-list-group>
                <b-list-group-item :key="productIndex" v-for="(product, productIndex) in products">
                    <div class="fl-list">
                        <div class="grid-serial">
                            <div class="serial-saved">
                                <div v-b-toggle="`collapse-${productIndex}`">{{ product.serial }}</div>
                            </div>
                            <div class="hose-serial">
                                <div v-if="product.hosekit && product.hosekit.selected">
                                    <b-input-group :prepend="product.hosekit.selected.description + ' (' + product.hosekit.selected.serial + ')'" append="quantity" size="sm">
                                        <b-form-input v-model="product.hosekit.selected.quantity"></b-form-input>
                                    </b-input-group>
                                </div>
                            </div>
                        </div>
                        <div>
                            <b-button v-if="product.hosekit" v-b-modal="`hosekit-modal-${productIndex}`" href="#" size="sm" variant="outline-secondary">Choose Hose Kit</b-button>
                        </div>
                    </div>

                    <b-collapse :id="`collapse-${productIndex}`" class="mt-2">
                        <b-table striped hover :items="product.parts"></b-table>
                    </b-collapse>

                    <hose-kit-container :product-id="productIndex" v-if="product.hosekit" :options="product.hosekit.options" @result="onHoseKitResult" />

                </b-list-group-item>
            </b-list-group>

            <div v-if="products.length" class="bt-grid">
                <div>
                    <b-button block href="#" variant="primary" size="lg" class="mt-5" @click="onExportToFile('xlsx')">Export to Excel</b-button>
                </div>
                <div>
                    <b-button block href="#" variant="primary" size="lg" class="mt-5" @click="onExportToFile('pdf')">Export to PDF</b-button>
                </div>
            </div>
        </div>


      <b-modal v-model="shouldShowModal" :id="`hvd-config-modal`" size="sm" title="Horizontal, Vertical, and Downflow Configuration Details" style="width: 600px;" centered scrollable no-fade hide-footer>
        <b-table-simple small responsive borderless>
          <b-tbody>

          <b-tr>
            <b-td colspan="3" class="text-center font-weight-bold bg-dark text-light">Horizontal Configuration</b-td>
          </b-tr>
          <b-tr>
            <b-td colspan="1" class="text-center bg-info font-weight-bold">Supply</b-td>
            <b-td colspan="2" class="text-center font-weight-bold">Return</b-td>
          </b-tr>
          <b-tr>
            <b-td class="text-center">&nbsp;</b-td>
            <b-td class="text-center font-weight-bold">Left</b-td>
            <b-td class="text-center font-weight-bold">Right</b-td>
          </b-tr>
          <b-tr>
            <b-td class="text-center bg-info">Straight</b-td>
            <b-td class="text-center">L</b-td>
            <b-td class="text-center">R</b-td>
          </b-tr>
          <b-tr>
            <b-td class="text-center bg-info">Back</b-td>
            <b-td class="text-center">B</b-td>
            <b-td class="text-center">P</b-td>
          </b-tr>

          <b-tr>
            <b-td colspan="3" class="text-center font-weight-bold bg-dark text-light">Downflow Configuration</b-td>
          </b-tr>
          <b-tr>
            <b-td colspan="1" class="text-center bg-info font-weight-bold">Supply</b-td>
            <b-td colspan="2" class="text-center font-weight-bold">Return</b-td>
          </b-tr>
          <b-tr>
            <b-td class="text-center">&nbsp;</b-td>
            <b-td class="text-center font-weight-bold">Left</b-td>
            <b-td class="text-center font-weight-bold">Right</b-td>
          </b-tr>
          <b-tr>
            <b-td class="text-center bg-info">Down</b-td>
            <b-td class="text-center">D</b-td>
            <b-td class="text-center">N</b-td>
          </b-tr>

          <b-tr>
            <b-td colspan="3" class="text-center font-weight-bold bg-dark text-light">Vertical Configuration</b-td>
          </b-tr>
          <b-tr>
            <b-td colspan="1" class="text-center bg-info font-weight-bold">Supply</b-td>
            <b-td colspan="2" class="text-center font-weight-bold">Return</b-td>
          </b-tr>
          <b-tr>
            <b-td class="text-center">&nbsp;</b-td>
            <b-td class="text-center font-weight-bold">Left</b-td>
            <b-td class="text-center font-weight-bold">Right</b-td>
          </b-tr>
          <b-tr>
            <b-td class="text-center bg-info">Top</b-td>
            <b-td class="text-center">T</b-td>
            <b-td class="text-center">K</b-td>
          </b-tr>

          <b-tr>
            <b-td colspan="3" class="text-center font-weight-bold bg-dark text-light">MB Series Vertical Only</b-td>
          </b-tr>
          <b-tr>
            <b-td colspan="2" class="text-center bg-info font-weight-bold">Return/Supply</b-td>
            <b-td colspan="1" class="text-center font-weight-bold">Option</b-td>
          </b-tr>
          <b-tr>
            <b-td colspan="2" class="text-center bg-info">Front/Top</b-td>
            <b-td colspan="1" class="text-center">F</b-td>
          </b-tr>
          <b-tr>
            <b-td colspan="2" class="text-center bg-info">Back/Top</b-td>
            <b-td colspan="1" class="text-center">C</b-td>
          </b-tr>
          <b-tr>
            <b-td colspan="2" class="text-center bg-info">Back/Front</b-td>
            <b-td colspan="1" class="text-center">G</b-td>
          </b-tr>
          <b-tr>
            <b-td colspan="2" class="text-center bg-info">Front/Back</b-td>
            <b-td colspan="1" class="text-center">H</b-td>
          </b-tr>

          </b-tbody>

        </b-table-simple>
      </b-modal>
    </b-container>
</template>

<script>
    import FileSaver from "file-saver"

    import BuilderContainer from "./builder/Container"
    import HoseKitContainer from "./HoseKit"

    import HoseKitUtils from "../utils/hosekit"

    export default {
        components: {
            BuilderContainer,
            HoseKitContainer
        },

        data () {
            return {
                shouldShowBuilder: false,
                shouldShowHoseKit: false,
                shouldShowModal: false,

                products: []
            }
        },

        methods: {
            showModal () {
              this.shouldShowModal = true;
            },
            hideModal () {
              this.shouldShowModal = false;
            },

            onGenerateSerial () {
                this.shouldShowBuilder = true
            },

            onBuilderResult (data) {
                let hosekit = false
                // check if a product has hosekit options
                if (data.parts.length > 0) {
                    let serial = data.parts[0].code.slice(0, -1)
                    let hosekitOptions = HoseKitUtils.select(serial)
                    if (hosekitOptions) {
                        hosekit = {selected: false, options: hosekitOptions}
                    }
                }

                this.products.push({
                    serial: data.serial,
                    parts: data.parts,
                    hosekit
                })

                this.shouldShowBuilder = false
            },

            onHoseKitResult (data) {
                let product = this.products[data.id]
                if (product.hosekit) {
                    product.hosekit.selected = {
                        ... data.product,
                        quantity: 1
                    }
                }
            },

            onExportToFile (type) {

                let products = []
                // -------------------------------
                this.products.forEach(product => {

                    let productDescription = []
                    product.parts.forEach(part => productDescription.push(part.description.trim()))
                    // ----------------------------------------------------------------
                    products.push({
                        serial: product.serial,
                        description: productDescription.join(' '),
                        hosekit: (product.hosekit && product.hosekit.selected)
                            ? product.hosekit.selected
                            : false
                    })
                })

                let params = {}
                // -------------------------------
                params.type = type
                params.products = products
                // -------------------------------

                this.$http.post('/api/export', params, {responseType: 'blob'}).then(response => {
                    FileSaver.saveAs(response.data, `report.${type}`)
                })
            }
        }
    }
</script>

<style scoped>
    @media (min-width: 576px) {
        .modal-dialog {
            max-width: 900px!important; 
        }
      .modal-width-600px {
        width: 600px !important;
      }
    }
    .fl-list {
        display: grid;
        grid-template-columns: 4fr 1fr;
    }
    .fl-list div {
        text-align:right;
    }
    .fl-list div:first-child {
        text-align:left;
    }
    .serial-saved {
        line-height: 31px;
        display:inline-block;
    }
    .grid-serial {
        display:grid;
        grid-template-columns: 1fr 1fr;
    }
    @media(max-width:1199px) {
      .grid-serial {
        grid-template-columns: 1fr 2fr;
        }      
    }
    .bt-grid {
        display:grid;
        grid-template-columns: 1fr 1fr;
    }
    .bt-grid div {
        padding-left:15px;
    }
    .bt-grid div:first-child {
        padding-right:15px;
        padding-left:0px;
    }
    .top-note {
        margin:30px 0px 0px;
        font-weight:bold;
    }
</style>
